// Global Instructions Rule Applied!
// Standalone route wrapper for the Fee Booking workbench (/fee-booking):
// fund selector enabled. The Fund form embeds the same component with the
// fund fixed.
import React from 'react'
import FeeBookingWorkbench from './FeeBookingWorkbench.tsx'

export default function FeeBookingPage() {
  return <FeeBookingWorkbench />
}
